/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this file will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
// Add custom code below this line

// Poll until theme.js has written the % value, then replace with $ amount
var saleBadgeInterval = setInterval(function() {
  var amountEl = document.querySelector('[data-price-off-amount]');
  if (!amountEl) return;

  var currentText = amountEl.textContent.trim();
  if (!currentText || currentText === '') return;

  if (amountEl.dataset.overridden === 'true') {
    clearInterval(saleBadgeInterval);
    return;
  }

  var priceEl = document.querySelector('[data-product-price]');
  var comparePriceEl = document.querySelector('[data-compare-price]');
  if (!priceEl || !comparePriceEl) return;

  var price = parseFloat(priceEl.textContent.trim().replace(/[^0-9.]/g, ''));
  var comparePrice = parseFloat(comparePriceEl.textContent.trim().replace(/[^0-9.]/g, ''));
  if (!comparePrice || comparePrice <= price) return;

  var diff = (comparePrice - price).toFixed(2);
  var parts = diff.split('.');
  var dollars = parts[0];
  var cents = parts[1];

  amountEl.innerHTML =
    '$<span style="font-size:1.1em; letter-spacing:0.02em;">' + dollars + '</span>' +
    '<span style="font-size:0.8em; vertical-align:baseline; letter-spacing:0.01em;">.' + cents + '</span>' +
    '\u00A0';
  amountEl.dataset.overridden = 'true';

  var badge = amountEl.closest('[data-price-off-badge]');
  if (badge) {
    badge.style.textTransform = 'none';
    badge.classList.remove('hidden');
  }

  clearInterval(saleBadgeInterval);
}, 50);

// Reset on variant change so it re-runs
function resetSaleBadge() {
  var amountEl = document.querySelector('[data-price-off-amount]');
  if (amountEl) delete amountEl.dataset.overridden;
  clearInterval(saleBadgeInterval);
  saleBadgeInterval = setInterval(resetSaleBadge, 50);
}
document.addEventListener('variant:changed', resetSaleBadge);
document.addEventListener('variantChange', resetSaleBadge);

// ^^ Keep your scripts inside this IIFE function call to
// avoid leaking your variables into the global scope.
})();

/* Compact and centre product videos */
(function () {
  const style = document.createElement('style');

  style.textContent = `
    /* Broadcast-wrapped YouTube videos */
    .rte__video-wrapper {
      width: 358px !important;
      max-width: 100% !important;
      height: 208px !important;
      padding-bottom: 0 !important;
      margin: 0 auto 18px auto !important;
      position: relative !important;
      overflow: hidden !important;
    }

    .rte__video-wrapper iframe {
      position: absolute !important;
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height: 100% !important;
    }

    /* Older YouTube embeds sitting directly inside a paragraph */
    .easytabs-content-holder p > iframe[src*="youtube.com/embed/"],
    .easytabs-content-holder p > iframe[src*="youtube-nocookie.com/embed/"] {
      width: 358px !important;
      max-width: 100% !important;
      height: 208px !important;
      display: block !important;
      margin: 0 auto 18px auto !important;
      position: static !important;
      border: 0 !important;
    }
  `;

  document.head.appendChild(style);
})();